import React from "react";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/sidebar/app-sidebar";
import { Button } from "@/components/ui/button";
import { useNavigate, Link } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div className="flex h-full flex-col items-center justify-center p-6 text-center">
          <div className="max-w-md">
            <h1 className="text-4xl font-bold tracking-tight">404</h1>
            <p className="mt-3 text-lg text-muted-foreground">Page introuvable</p>
            <p className="mt-2 text-sm text-muted-foreground">
              Désolé, la page que vous cherchez n'existe pas ou a été déplacée.
            </p>

            <div className="mt-6 flex items-center justify-center gap-3">
              <Button variant="secondary" onClick={() => navigate(-1)}>
                Revenir en arrière
              </Button>
              <Button asChild>
                <Link to="/">Aller au tableau de bord</Link>
              </Button>
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
